var $9c688563b1176630$exports = {};
$9c688563b1176630$exports = {
    "pending": `f\xfcgg\u{151}ben lev\u{151}`
};


export {$9c688563b1176630$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
